import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { StaticFileModule } from "./enums";
import { StaticFileInitialization } from "./types";

const INITIALIZE_STATIC_FILES = ApiRequestAdapter.create("/files/static/{0}/initialize", HttpMethod.POST);

export const staticFilesApi = {
  initialize: (module: StaticFileModule): AxiosPromise<StaticFileInitialization> => {
    return apiService.post(INITIALIZE_STATIC_FILES.getParametrizedUrl(module));
  },
};
